define([
    'santa-components',
    'coreUtils',
    'lodash',
    'skins',
    'spotifyPlayer/skins/skins.json',
    'componentsCore'
], function (santaComponents, coreUtils, _, skinsPackage, skinsJson, componentsCore) {
    'use strict';

    const urlUtils = coreUtils.urlUtils;
    const baseUrl = 'https://embed.spotify.com/?';

    const sizeLimits = {
        compact: {
            minW: 250,
            minH: 80
        },
        large: {
            minW: 250,
            minH: 330
        }
    };

    /**
     * Get the iframe source
     * @param uri
     * @param color
     * @param style
     * @returns {string}
     */
    function getIframeSrc(uri, color, style) {
        const queryParams = {
            uri,
            theme: color,
            view: style
        };
        return baseUrl + urlUtils.toQueryString(queryParams);
    }

    /**
     *
     * @param compData
     * @returns {{}}
     */
    function getPlaceHolderProperties(compData) {
        const placeHolderProps = {};

        if (_.size(compData.uri) > 0) {
            placeHolderProps.style = {};
            placeHolderProps.style.display = 'none';
        }

        return placeHolderProps;
    }

    function calculateIframeHeight(compProp, compStyle) {
        let height = sizeLimits[compProp.size].minH;
        if (compProp.size === 'large') {
            height += compStyle.width - sizeLimits[compProp.size].minW;
        }
        return height;
    }

    /**
     *
     * @param compProp
     * @param compData
     * @param compStyle
     * @returns {{}}
     */
    function getIframeProperties(compProp, compData, compStyle) {
        const iframe = {};
        if (_.size(compData.uri) > 0) {
            iframe['data-src'] = getIframeSrc(compData.uri, compProp.color, compProp.style);
            iframe.style = {
                width: compStyle.width,
                height: calculateIframeHeight(compProp, compStyle)
            };
        } else {
            iframe.style = {
                display: 'none'
            };
        }

        return iframe;
    }

    /**
     * @class components.spotifyPlayer
     * @extends {core.skinBasedComp}
     */
    const spotifyPlayer = {
        displayName: 'SpotifyPlayer',
        mixins: [componentsCore.mixins.skinBasedComp],

        propTypes: {
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired,
            compProp: santaComponents.santaTypesDefinitions.Component.compProp.isRequired,
            style: santaComponents.santaTypesDefinitions.Component.style.isRequired
        },

        getSkinProperties() {
            const a11yTitle = 'Spotify Player';
            return {
                '': {
                    style: {
                        //We add stupid extra 2 pixels for backward compatibility with HTML-CLIENT
                        height: calculateIframeHeight(this.props.compProp, this.props.style) + 2
                    },
                    tabIndex: 0,
                    title: a11yTitle,
                    'aria-label': a11yTitle

                },
                iframe: getIframeProperties(this.props.compProp, this.props.compData, this.props.style),
                placeholder: getPlaceHolderProperties(this.props.compData)
            };
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.common.components.spotifyplayer.viewer.SpotifyPlayer', spotifyPlayer);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return spotifyPlayer;
});
